<div class="row" *ngIf="candidateActivities">
    <div class="col-md-5 pr-0">
        <p class="f-12 mb-1">Filter</p>
        <div class="mb-1 d-flex justify-content-between">
            <select data-testid="auto-app-activity-tab-select-1" class="nobg wc-form-control-activity pipeline-text-border" (change)="setActivityType($event.target.value)">
                <option value="all">All Activity type</option>
                <option value="note"> Note </option>
                <option value="tags"> Tag </option>
            </select>
            <div class="selectdrop-down position-relative tr-n f-12 mt-3 mr-2"><i class="fas fa-chevron-down"></i></div>
        </div>
    </div>
    <div class="col-md-5 pl-0">
        <p class="f-12 mb-1">Sort</p>
        <span class="mb-1 d-flex justify-content-between">
            <select data-testid="auto-app-activity-tab-select-2" class="nobg wc-form-control-activity pipeline-text-border" (change)="sortActivity($event.target.value)">
                <option value="recent" selected>Most Recent</option>
                <option value="old">Oldest</option>
            </select>
            <span class="selectdrop-down position-relative tr-n f-12 mt-3 mr-2"><i class="fas fa-chevron-down"></i></span>
        </span>
    </div>
</div>

<div class="activities-list mt-4" *ngIf="candidateActivities">
    <div class="candidate-activities" *ngFor="let activity of candidateActivities; let i = index">
        <div class="note">
            <div class="row mb-1">
                <div class="col d-flex">
                    <div class="">
                        <i class="fas fa-circle f-12 webtree-btn-1"></i>
                    </div>
                    <div class="col gray-text f-12 line-height-1 pl-2">
                        <p class="mb-0">
                            <span [innerHTML]="getActivityText(activity)"></span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="row mb-1">
                <div class="col d-flex">
                    <div class="pr-2 d-flex align-items-stretch">
                        <div class="spacer2 pr-2 spacer-border"></div>
                    </div>
                    <div class="col gray-text f-12 line-height-1">
                        <p class="mb-4 f-12">
                            <span class="mr-2 f-12">{{activity?.loginfirstname}} {{activity?.loginlastname}} </span>

                            <i class="fas fa-circle mr-2" style="font-size: 5px;"></i>
                            <span class="mr-2">{{activity?.createdon | date: 'MMM dd, yyyy'}}</span>
                            <i class="fas fa-circle mr-2" style="font-size: 5px;"></i>
                            <span>{{activity?.createdon | date: 'h:mm a'}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>